import gql from 'graphql-tag';
import SubsectionNavItemFragment from './SubsectionNavItemFragment.gql';

export default gql`
  fragment SubsectionNavFragment on SubsectionNavItem {
    id
    type
    data {
      menuItems {
        ...SubsectionNavItemFragment
      }
    }
  }
  ${SubsectionNavItemFragment}
`;
